import "../scss/style.scss";
import { initPromoBannerParallax } from "./partials/PageContent/promoBannerParallax";
import { initAdvancedHeroSlider } from "./partials/PageContent/advancedHeroSlider";

// CORE BİLEŞENLERİNİ OVERRIDE EDİYORUZ
window.ThemeComponentOverrides = {
  // 1. Ürün Detay Sayfası
  ProductSingle: {
    import: () =>
      import("./templates/ecommerce/product/components/ProductSingle/MtcProductSingle"),
    needsRouter: true,
  },
  // 2. Hızlı Bakış Modalı (Yeni Eklenen)
  ProductModal: {
    import: () =>
      import("./templates/ecommerce/product/components/common/ProductModal/MtcProductModal"),
  },
};

const bootTheme = () => {
  console.log("[Client Theme] Initialized.");
  initPromoBannerParallax();
  initAdvancedHeroSlider();
};

if (window.EcommerceCore) {
  bootTheme();
} else {
  window.addEventListener("ecommerce_core_ready", bootTheme);
}
